import { Component, OnInit } from '@angular/core';
import { AppService, UserService, HttpService, RouterService } from 'src/app/core';
import { LoaderService } from 'src/app/core/services/loader/loader.service';
import { Router } from '@angular/router'
import { isNullOrUndefined } from 'util';
import { Subject } from 'rxjs';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  usuario: string;
  password: string;
  sendRecupero: boolean;
  error: Subject<boolean> = this.httpService.errorLogin;
  recuperar: boolean = false;
  mailRecupero: string;
  formatoMail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  constructor(private appService: AppService,
    private userService: UserService,
    private router: Router,
    private httpService: HttpService,
    private loaderService: LoaderService,
    private routerService: RouterService) { }

  ngOnInit() {
    if (!isNullOrUndefined(localStorage.getItem('token')) && !isNullOrUndefined(sessionStorage.getItem('user'))) {
      let userInfo = JSON.parse(sessionStorage.getItem('user'));
      this.userService.setUser(userInfo);
      this.appService.setToken(localStorage.getItem('token'));
      this.appService.setRefreshToken(localStorage.getItem('refreshToken'));
      if (userInfo.user.cambiarPassword) {
        this.router.navigate(['restorePassword']);
      } else {
        this.router.navigate(['intranet/novedades/home']);
      }
    }
  }

  login() {
    let request = {
      username: this.usuario,
      password: this.password
    };

    this.userService.login(request).subscribe(data => {
      localStorage.setItem('token', JSON.stringify(data));
      localStorage.setItem('token', data.token);
      localStorage.setItem('refreshToken', data.refreshToken);
      this.appService.setToken(data.token);
      this.appService.setRefreshToken(data.refreshToken);
      this.userService.userInfo()
        .subscribe(data => {
          this.userService.setUser(data);
          sessionStorage.setItem('user', JSON.stringify(data));
          if (this.userService.cambiarPassword()) {
            this.router.navigate(['restorePassword']);
          } else {
            if (!isNullOrUndefined(this.routerService.getCancelUrl())) {
              this.router.navigate([this.routerService.getCancelUrl()]);
              this.routerService.clearCancelUrl();
            } else {
              this.router.navigate(['/intranet/novedades/home']);
            }
          }
        });
    })
  }
  showRecuperar() {
    this.recuperar = !this.recuperar;
  }
  recuperarPassword() {
    let req = { email: this.mailRecupero };
    this.userService.sendMail(req)
      .subscribe(data => {
        Swal.fire({
          icon: 'success',
          title: 'En los próximos 5 minutos te llegará un mail',
          showConfirmButton: false,
          timer: 2000
        });
      });
    this.recuperar = false;
    this.error.next(false);
    this.usuario = '';
    this.password = '';
    this.mailRecupero = '';
  }
  checkMail() {
    if (this.formatoMail.test(this.mailRecupero)) {
      this.sendRecupero = true;
    } else {
      this.sendRecupero = false;
    }
  }
}
